// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"116": "8d58ce02","122": "21a578a4","354": "9c6094ad","36": "830872fd","365": "a624f475","535": "d87ce218","58": "ecce2176","633": "3706562f","646": "53ff550e","783": "f7c901c3","819": "76b7257b",}[chunkId] + ".js"
}